import { createFileRoute } from "@tanstack/react-router";
import { useRef, useState } from "react";
import { Sheet, type SheetRef } from "react-modal-sheet";

const snapPoints = [0, 100, 0.5, 1];
const initialSnap = 1;
const lastSnap = snapPoints.length - 1;

/**
 * Bare-bones test route to isolate react-modal-sheet scrolling behavior.
 * If scrolling works here but not on /search, the issue is page-level.
 */
function TestSheet() {
  const sheetRef = useRef<SheetRef | null>(null);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(true);
  const [snapPoint, setSnapPoint] = useState(initialSnap);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100dvh",
        background: "#e5e7eb",
      }}
    >
      <p style={{ padding: 16 }}>
        Background content. Sheet should scroll below.
      </p>

      <Sheet
        ref={sheetRef}
        isOpen={isOpen}
        snapPoints={snapPoints}
        initialSnap={initialSnap}
        disableDismiss
        onClose={() => setIsOpen(false)}
        onSnap={setSnapPoint}
      >
        <Sheet.Container>
          <Sheet.Header />
          <Sheet.Content
            disableScroll={(state) => state.currentSnap !== lastSnap}
            scrollRef={scrollRef}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 16,
                padding: 16,
              }}
            >
              {Array.from({ length: 30 }, (_, i) => (
                <div
                  key={i}
                  style={{
                    height: 96,
                    borderRadius: 8,
                    backgroundColor: "#9ca3af",
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#374151",
                    fontFamily: "monospace",
                    fontSize: 16,
                  }}
                >
                  Item {i + 1}
                </div>
              ))}
            </div>
          </Sheet.Content>
        </Sheet.Container>
        {snapPoint === lastSnap && <Sheet.Backdrop />}
      </Sheet>
    </div>
  );
}

export const Route = createFileRoute("/test-sheet")({
  component: TestSheet,
});
